import script from "./vatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./vatPage.vue?vue&type=script&setup=true&lang=js"

import "./vatPage.vue?vue&type=style&index=0&id=6f14a887&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f14a887"]])

export default __exports__